import { render, staticRenderFns } from "./PasswordResetModal.vue?vue&type=template&id=3cd53c92&scoped=true&"
import script from "./PasswordResetModal.vue?vue&type=script&lang=js&"
export * from "./PasswordResetModal.vue?vue&type=script&lang=js&"
import style0 from "./PasswordResetModal.vue?vue&type=style&index=0&id=3cd53c92&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd53c92",
  null
  
)

export default component.exports